module.exports = __webpack_public_path__ + "img/JPG.4e6facaf.png";